import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRechargeHistories } from "../../../api/history";
import { getListDashboardUser } from "../../../api/dashboard";

// First, create the thunk
export const fetchDashboardUser = createAsyncThunk(
  "news/fetchDashboardUser",
  async ({ query }: { query: string }) => {
    try {
      const response = await getListDashboardUser(query);
      return response?.data;
    } catch (error) {
      
    }
  }
);

const initialState: any = {
  isFetching: true,
  pagination: {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
  },
  result: [],
};

export const dashboardUserSlice = createSlice({
  name: "news",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchDashboardUser.pending, (state) => {
      state.isFetching = true;
    });

    builder.addCase(fetchDashboardUser.rejected, (state) => {
      state.isFetching = false;
    });

    builder.addCase(fetchDashboardUser.fulfilled, (state, action) => {
      state.isFetching = false;
      state.pagination = action.payload?.pagination;
      state.result = action.payload?.data;
    });
  },
});

export const {} = dashboardUserSlice.actions;

export default dashboardUserSlice.reducer;
